import {
    PortfolioReturnsComponentState,
    initialPortfolioReturnsComponentState,
} from './component/PortfolioReturnsComponentState';
import {
    initialPortfolioReturnsStreamState,
    PortfolioReturnsDataState,
} from './stream/PortfolioReturnsStreamState';
import {
    PortfolioReturnsConfigurationState,
    initialPortfolioReturnsConfigurationState,
} from './configuration/PortfolioReturnsConfigurationState';
import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';

export type PortfolioReturnsWidgetState =
    StreamingWidgetState<PortfolioReturnsDataState> &
        WidgetWithConfigState<PortfolioReturnsConfigurationState> &
        WidgetWithComponentState<PortfolioReturnsComponentState>;

export interface PortfolioReturnsWidgetsState {
    [widgetId: string]: PortfolioReturnsWidgetState;
}

export const initialPortfolioReturnsWidgetState: PortfolioReturnsWidgetState = {
    component: initialPortfolioReturnsComponentState,
    config: initialPortfolioReturnsConfigurationState,
    stream: initialPortfolioReturnsStreamState,
};

export const initialPortfolioReturnsWidgetsState: PortfolioReturnsWidgetsState =
    {};
